
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/[uid]",
      function () {
        return require("private-next-pages/magazine/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/[uid]"])
      });
    }
  